import Enums from 'utils/EnumsManager';

const { VIEWDETAILS } = Enums.REDUX_ACTION_TYPE_PREFIX;

const SET_MODULE_DATA = `${VIEWDETAILS}SET_MODULE_DATA`;
const SET_MODULES = `${VIEWDETAILS}SET_MODULES`;
const RESET_MODULES = `${VIEWDETAILS}RESET_MODULES`;
const SET_MODULE_READONLYMODE = 'SET_MODULE_READONLYMODE';
const RESET_MODULE_READONLYMODE = 'RESET_MODULE_READONLYMODE';

export {
  SET_MODULE_DATA,
  SET_MODULES,
  RESET_MODULES,
  SET_MODULE_READONLYMODE,
  RESET_MODULE_READONLYMODE
};



// WEBPACK FOOTER //
// ./src/components/page/DetailsSubpanels/flow/actionTypes.js